import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    if (localStorage.getItem('blog_signup_modal_dismissed')) {
      this.element.remove()
    }
  }

  close() {
    localStorage.setItem('blog_signup_modal_dismissed', 'true')
    this.element.remove()
  }
}
